import App from 'apps/invite-designer/components/app';
import initResponsivenessScore from 'apps/responsiveness-score/';
import ResponsivenessScoreContentListing from 'apps/responsiveness-score/components/responsiveness-score-content-listing';

import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';

const responsivenessScoreNode = document.querySelector(
    '[data-responsiveness-score-origin=invites]'
);

document.addEventListener('DOMContentLoaded', () => {
    if (responsivenessScoreNode) {
        initResponsivenessScore(responsivenessScoreNode, ResponsivenessScoreContentListing);
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const appNode = document.getElementById('invite-designer-root');
    const appDataNode = document.getElementById('invite-designer-app-data');
    const { initData } = JSON.parse(appDataNode.textContent);

    const { intlData, designerId, contests, urls } = initData;

    ReactDOM.render(
        <IntlProvider {...intlData}>
            <App
                inviteDesignerUrl={urls.inviteDesignerUrl.href}
                findDesignersUrl={urls.findDesignersUrl.href}
                favoriteDesignersUrl={urls.favoriteDesignersUrl.href}
                designerId={designerId}
                contests={contests}
            />
        </IntlProvider>,
        appNode
    );
});



// WEBPACK FOOTER //
// ./src/js/page/profiles-invites.jsx